var map = {
	"../../staff/staff-entry/module": [
		"./src/app/modules/session/staff-routes/staff/staff-entry/module.ts",
		"default~staff-entry-module~staff-routes-staff-module",
		"common"
	],
	"../../student/student-entry/module": [
		"./src/app/modules/session/staff-routes/student/student-entry/module.ts",
		"default~admission-view-module~student-entry-module",
		"common",
		"student-entry-module"
	],
	"../staff/staff-entry/module": [
		"./src/app/modules/session/staff-routes/staff/staff-entry/module.ts",
		"default~staff-entry-module~staff-routes-staff-module",
		"common"
	],
	"../student/student-entry/module": [
		"./src/app/modules/session/staff-routes/student/student-entry/module.ts",
		"default~admission-view-module~student-entry-module",
		"common",
		"student-entry-module"
	],
	"./add/module": [
		"./src/app/modules/session/staff-routes/student_merit_update/add/module.ts",
		"add-module"
	],
	"./admission-list/module": [
		"./src/app/modules/session/staff-routes/admission-authorization/admission-list/module.ts",
		"admission-list-module"
	],
	"./admission-view/module": [
		"./src/app/modules/session/staff-routes/admission-authorization/admission-view/module.ts",
		"default~admission-view-module~modules-non-session-module",
		"default~admission-view-module~student-entry-module",
		"common",
		"admission-view-module"
	],
	"./attendance-register-add/module": [
		"./src/app/modules/session/staff-routes/attendance-register/attendance-register-add/module.ts",
		"common",
		"attendance-register-add-module"
	],
	"./attendance-register-list/module": [
		"./src/app/modules/session/staff-routes/attendance-register/attendance-register-list/module.ts",
		"common",
		"attendance-register-list-module"
	],
	"./attendance-register-view/module": [
		"./src/app/modules/session/staff-routes/attendance-register/attendance-register-view/module.ts",
		"attendance-register-view-module"
	],
	"./branch-entry/module": [
		"./src/app/modules/session/staff-routes/branch/branch-entry/module.ts",
		"default~branch-entry-module~staff-routes-branch-module",
		"common"
	],
	"./concession-add/module": [
		"./src/app/modules/session/staff-routes/concession/concession-add/module.ts",
		"default~concession-add-module~fee_type_breakup_add-module~fee_type_breakup_list-module~new-concessio~4cd420e4",
		"common",
		"concession-add-module"
	],
	"./concession-modify/module": [
		"./src/app/modules/session/staff-routes/concession/concession-modify/module.ts",
		"common",
		"concession-modify-module"
	],
	"./concession-view/module": [
		"./src/app/modules/session/staff-routes/concession/concession-view/module.ts",
		"common",
		"concession-view-module"
	],
	"./course-registration-enter/module": [
		"./src/app/modules/session/staff-routes/course-registration-student/course-registration-enter/module.ts",
		"default~course-registration-enter-module~staff-routes-course-registration-student-module",
		"common"
	],
	"./department-entry/module": [
		"./src/app/modules/session/staff-routes/department/department-entry/module.ts",
		"default~department-entry-module~staff-routes-department-module",
		"common"
	],
	"./designation-entry/module": [
		"./src/app/modules/session/staff-routes/designation/designation-entry/module.ts",
		"default~designation-entry-module~staff-routes-designation-module",
		"common"
	],
	"./fee-structure-add/module": [
		"./src/app/modules/session/staff-routes/fee-structure/fee-structure-add/module.ts",
		"common",
		"fee-structure-add-module"
	],
	"./fee-structure-list/module": [
		"./src/app/modules/session/staff-routes/fee-structure/fee-structure-list/module.ts",
		"common",
		"fee-structure-list-module"
	],
	"./fee-structure-view/module": [
		"./src/app/modules/session/staff-routes/fee-structure/fee-structure-view/module.ts",
		"common",
		"fee-structure-view-module"
	],
	"./fee-type-add/module": [
		"./src/app/modules/session/staff-routes/fee-new/fee-type-add/module.ts",
		"common",
		"fee-type-add-module"
	],
	"./fee-type-view/module": [
		"./src/app/modules/session/staff-routes/fee-new/fee-type-view/module.ts",
		"common",
		"fee-type-view-module"
	],
	"./fee_type_breakup_add/module": [
		"./src/app/modules/session/staff-routes/fee_type_breakup/fee_type_breakup_add/module.ts",
		"default~concession-add-module~fee_type_breakup_add-module~fee_type_breakup_list-module~new-concessio~4cd420e4",
		"common",
		"fee_type_breakup_add-module"
	],
	"./fee_type_breakup_list/module": [
		"./src/app/modules/session/staff-routes/fee_type_breakup/fee_type_breakup_list/module.ts",
		"default~concession-add-module~fee_type_breakup_add-module~fee_type_breakup_list-module~new-concessio~4cd420e4",
		"common",
		"fee_type_breakup_list-module"
	],
	"./forgot-password/module": [
		"./src/app/modules/non-session/forgot-password/module.ts",
		"common",
		"forgot-password-module"
	],
	"./group-add/module": [
		"./src/app/modules/session/staff-routes/group/group-add/module.ts",
		"common",
		"group-add-module"
	],
	"./group-list/module": [
		"./src/app/modules/session/staff-routes/group/group-list/module.ts",
		"common",
		"group-list-module"
	],
	"./landing-page/module": [
		"./src/app/modules/non-session/landing-page/module.ts",
		"default~landing-page-module~registration-module",
		"common",
		"landing-page-module"
	],
	"./marks-entry-all-subject-add/module": [
		"./src/app/modules/session/staff-routes/marks-entry-all-subject/marks-entry-all-subject-add/module.ts",
		"common",
		"marks-entry-all-subject-add-module"
	],
	"./marks-entry-all-subject-edit/module": [
		"./src/app/modules/session/staff-routes/marks-entry-all-subject/marks-entry-all-subject-edit/module.ts",
		"common",
		"marks-entry-all-subject-edit-module"
	],
	"./marks-entry-all-subject-list/module": [
		"./src/app/modules/session/staff-routes/marks-entry-all-subject/marks-entry-all-subject-list/module.ts",
		"common",
		"marks-entry-all-subject-list-module"
	],
	"./marks-entry-new-add/module": [
		"./src/app/modules/session/staff-routes/marks-entry-new/marks-entry-new-add/module.ts",
		"common",
		"marks-entry-new-add-module"
	],
	"./marks-entry-new-edit/module": [
		"./src/app/modules/session/staff-routes/marks-entry-new/marks-entry-new-edit/module.ts",
		"common",
		"marks-entry-new-edit-module"
	],
	"./marks-entry-new-list/module": [
		"./src/app/modules/session/staff-routes/marks-entry-new/marks-entry-new-list/module.ts",
		"common",
		"marks-entry-new-list-module"
	],
	"./modules/non-session/module": [
		"./src/app/modules/non-session/module.ts",
		"default~modules-non-session-module~staff-routes-course-management-module",
		"default~admission-view-module~modules-non-session-module",
		"common",
		"modules-non-session-module"
	],
	"./modules/session/module": [
		"./src/app/modules/session/module.ts",
		"modules-session-module"
	],
	"./new-concession-add/module": [
		"./src/app/modules/session/staff-routes/new-concession/new-concession-add/module.ts",
		"default~concession-add-module~fee_type_breakup_add-module~fee_type_breakup_list-module~new-concessio~4cd420e4",
		"common",
		"new-concession-add-module"
	],
	"./new-concession-modify/module": [
		"./src/app/modules/session/staff-routes/new-concession/new-concession-modify/module.ts",
		"common",
		"new-concession-modify-module"
	],
	"./new-concession-view/module": [
		"./src/app/modules/session/staff-routes/new-concession/new-concession-view/module.ts",
		"common",
		"new-concession-view-module"
	],
	"./online-payment/module": [
		"./src/app/modules/non-session/online-payment/module.ts",
		"default~online-payment-module~staff-routes-challan-module~staff-routes-fee-payment-module~staff-rout~185feaa2",
		"common",
		"online-payment-module"
	],
	"./parent-login/module": [
		"./src/app/modules/non-session/parent-login/module.ts",
		"common",
		"parent-login-module"
	],
	"./registration/module": [
		"./src/app/modules/non-session/registration/module.ts",
		"default~landing-page-module~registration-module",
		"common",
		"registration-module"
	],
	"./regulation-entry/module": [
		"./src/app/modules/session/staff-routes/regulations/regulation-entry/module.ts",
		"default~regulation-entry-module~staff-routes-regulations-module",
		"common"
	],
	"./staff-entry/module": [
		"./src/app/modules/session/staff-routes/staff/staff-entry/module.ts",
		"default~staff-entry-module~staff-routes-staff-module",
		"common"
	],
	"./staff-routes/admission-authorization/module": [
		"./src/app/modules/session/staff-routes/admission-authorization/module.ts",
		"staff-routes-admission-authorization-module"
	],
	"./staff-routes/appraisee-entry/module": [
		"./src/app/modules/session/staff-routes/appraisee-entry/module.ts",
		"common",
		"staff-routes-appraisee-entry-module"
	],
	"./staff-routes/appraiser-entry/module": [
		"./src/app/modules/session/staff-routes/appraiser-entry/module.ts",
		"common",
		"staff-routes-appraiser-entry-module"
	],
	"./staff-routes/attendance-all-subject/module": [
		"./src/app/modules/session/staff-routes/attendance-all-subject/module.ts",
		"common",
		"staff-routes-attendance-all-subject-module"
	],
	"./staff-routes/attendance-config/module": [
		"./src/app/modules/session/staff-routes/attendance-config/module.ts",
		"common",
		"staff-routes-attendance-config-module"
	],
	"./staff-routes/attendance-consolidate-report/module": [
		"./src/app/modules/session/staff-routes/attendance-consolidate-report/module.ts",
		"common",
		"staff-routes-attendance-consolidate-report-module"
	],
	"./staff-routes/attendance-register/module": [
		"./src/app/modules/session/staff-routes/attendance-register/module.ts",
		"staff-routes-attendance-register-module"
	],
	"./staff-routes/attendance-report-new/module": [
		"./src/app/modules/session/staff-routes/attendance-report-new/module.ts",
		"common",
		"staff-routes-attendance-report-new-module"
	],
	"./staff-routes/attendance/module": [
		"./src/app/modules/session/staff-routes/attendance/module.ts",
		"common",
		"staff-routes-attendance-module"
	],
	"./staff-routes/authorization/module": [
		"./src/app/modules/session/staff-routes/authorization/module.ts",
		"common",
		"staff-routes-authorization-module"
	],
	"./staff-routes/authorization/status/module": [
		"./src/app/modules/session/staff-routes/authorization/status/module.ts",
		"staff-routes-authorization-status-module"
	],
	"./staff-routes/branch/module": [
		"./src/app/modules/session/staff-routes/branch/module.ts",
		"default~branch-entry-module~staff-routes-branch-module",
		"common",
		"staff-routes-branch-module"
	],
	"./staff-routes/certificates/module": [
		"./src/app/modules/session/staff-routes/certificates/module.ts",
		"common",
		"staff-routes-certificates-module"
	],
	"./staff-routes/challan/module": [
		"./src/app/modules/session/staff-routes/challan/module.ts",
		"default~concession-add-module~fee_type_breakup_add-module~fee_type_breakup_list-module~new-concessio~4cd420e4",
		"default~online-payment-module~staff-routes-challan-module~staff-routes-fee-payment-module~staff-rout~185feaa2",
		"common",
		"staff-routes-challan-module"
	],
	"./staff-routes/cie-mark-modify/module": [
		"./src/app/modules/session/staff-routes/cie-mark-modify/module.ts",
		"common",
		"staff-routes-cie-mark-modify-module"
	],
	"./staff-routes/classroom/module": [
		"./src/app/modules/session/staff-routes/classroom/module.ts",
		"common",
		"staff-routes-classroom-module"
	],
	"./staff-routes/classwise-fee-report/module": [
		"./src/app/modules/session/staff-routes/classwise-fee-report/module.ts",
		"common",
		"staff-routes-classwise-fee-report-module"
	],
	"./staff-routes/communication/module": [
		"./src/app/modules/session/staff-routes/communication/module.ts",
		"common",
		"staff-routes-communication-module"
	],
	"./staff-routes/concession/module": [
		"./src/app/modules/session/staff-routes/concession/module.ts",
		"staff-routes-concession-module"
	],
	"./staff-routes/consolidate_fee_details/module": [
		"./src/app/modules/session/staff-routes/consolidate_fee_details/module.ts",
		"common",
		"staff-routes-consolidate_fee_details-module"
	],
	"./staff-routes/consolidated-bu-report/module": [
		"./src/app/modules/session/staff-routes/consolidated-bu-report/module.ts",
		"common",
		"staff-routes-consolidated-bu-report-module"
	],
	"./staff-routes/course-management/module": [
		"./src/app/modules/session/staff-routes/course-management/module.ts",
		"default~modules-non-session-module~staff-routes-course-management-module",
		"common",
		"staff-routes-course-management-module"
	],
	"./staff-routes/course-registration-student/module": [
		"./src/app/modules/session/staff-routes/course-registration-student/module.ts",
		"default~course-registration-enter-module~staff-routes-course-registration-student-module",
		"common",
		"staff-routes-course-registration-student-module"
	],
	"./staff-routes/customize-field/module": [
		"./src/app/modules/session/staff-routes/customize-field/module.ts",
		"staff-routes-customize-field-module"
	],
	"./staff-routes/demotion/module": [
		"./src/app/modules/session/staff-routes/demotion/module.ts",
		"common",
		"staff-routes-demotion-module"
	],
	"./staff-routes/department/module": [
		"./src/app/modules/session/staff-routes/department/module.ts",
		"default~department-entry-module~staff-routes-department-module",
		"common",
		"staff-routes-department-module"
	],
	"./staff-routes/designation/module": [
		"./src/app/modules/session/staff-routes/designation/module.ts",
		"default~designation-entry-module~staff-routes-designation-module",
		"common",
		"staff-routes-designation-module"
	],
	"./staff-routes/fee-assign/module": [
		"./src/app/modules/session/staff-routes/fee-assign/module.ts",
		"staff-routes-fee-assign-module"
	],
	"./staff-routes/fee-assignment/module": [
		"./src/app/modules/session/staff-routes/fee-assignment/module.ts",
		"default~concession-add-module~fee_type_breakup_add-module~fee_type_breakup_list-module~new-concessio~4cd420e4",
		"common",
		"staff-routes-fee-assignment-module"
	],
	"./staff-routes/fee-new/module": [
		"./src/app/modules/session/staff-routes/fee-new/module.ts",
		"staff-routes-fee-new-module"
	],
	"./staff-routes/fee-payment/module": [
		"./src/app/modules/session/staff-routes/fee-payment/module.ts",
		"default~online-payment-module~staff-routes-challan-module~staff-routes-fee-payment-module~staff-rout~185feaa2",
		"common",
		"staff-routes-fee-payment-module"
	],
	"./staff-routes/fee-report/module": [
		"./src/app/modules/session/staff-routes/fee-report/module.ts",
		"common",
		"staff-routes-fee-report-module"
	],
	"./staff-routes/fee-structure/module": [
		"./src/app/modules/session/staff-routes/fee-structure/module.ts",
		"staff-routes-fee-structure-module"
	],
	"./staff-routes/fee_assigned/module": [
		"./src/app/modules/session/staff-routes/fee_assigned/module.ts",
		"common",
		"staff-routes-fee_assigned-module"
	],
	"./staff-routes/fee_dues/module": [
		"./src/app/modules/session/staff-routes/fee_dues/module.ts",
		"common",
		"staff-routes-fee_dues-module"
	],
	"./staff-routes/fee_payment_upload/module": [
		"./src/app/modules/session/staff-routes/fee_payment_upload/module.ts",
		"common",
		"staff-routes-fee_payment_upload-module"
	],
	"./staff-routes/fee_type_breakup/module": [
		"./src/app/modules/session/staff-routes/fee_type_breakup/module.ts",
		"staff-routes-fee_type_breakup-module"
	],
	"./staff-routes/feedback-alumni/module": [
		"./src/app/modules/session/staff-routes/feedback-alumni/module.ts",
		"common",
		"staff-routes-feedback-alumni-module"
	],
	"./staff-routes/feedback-download/module": [
		"./src/app/modules/session/staff-routes/feedback-download/module.ts",
		"common",
		"staff-routes-feedback-download-module"
	],
	"./staff-routes/feedback-faculty/module": [
		"./src/app/modules/session/staff-routes/feedback-faculty/module.ts",
		"common",
		"staff-routes-feedback-faculty-module"
	],
	"./staff-routes/feedback-on-syllabus/module": [
		"./src/app/modules/session/staff-routes/feedback-on-syllabus/module.ts",
		"common",
		"staff-routes-feedback-on-syllabus-module"
	],
	"./staff-routes/feedback-on-teacher/module": [
		"./src/app/modules/session/staff-routes/feedback-on-teacher/module.ts",
		"common",
		"staff-routes-feedback-on-teacher-module"
	],
	"./staff-routes/group/module": [
		"./src/app/modules/session/staff-routes/group/module.ts",
		"staff-routes-group-module"
	],
	"./staff-routes/individual_concession/module": [
		"./src/app/modules/session/staff-routes/individual_concession/module.ts",
		"common",
		"staff-routes-individual_concession-module"
	],
	"./staff-routes/intra-trust-admission/module": [
		"./src/app/modules/session/staff-routes/intra-trust-admission/module.ts",
		"common",
		"staff-routes-intra-trust-admission-module"
	],
	"./staff-routes/lesson_planning/module": [
		"./src/app/modules/session/staff-routes/lesson_planning/module.ts",
		"common",
		"staff-routes-lesson_planning-module"
	],
	"./staff-routes/marks-entry-all-subject/module": [
		"./src/app/modules/session/staff-routes/marks-entry-all-subject/module.ts",
		"staff-routes-marks-entry-all-subject-module"
	],
	"./staff-routes/marks-entry-new/module": [
		"./src/app/modules/session/staff-routes/marks-entry-new/module.ts",
		"staff-routes-marks-entry-new-module"
	],
	"./staff-routes/new-concession/module": [
		"./src/app/modules/session/staff-routes/new-concession/module.ts",
		"staff-routes-new-concession-module"
	],
	"./staff-routes/new-config_Classrooms/module": [
		"./src/app/modules/session/staff-routes/new-config_Classrooms/module.ts",
		"common",
		"staff-routes-new-config_Classrooms-module"
	],
	"./staff-routes/new-config_Students/module": [
		"./src/app/modules/session/staff-routes/new-config_Students/module.ts",
		"common",
		"staff-routes-new-config_Students-module"
	],
	"./staff-routes/new_fee_report/module": [
		"./src/app/modules/session/staff-routes/new_fee_report/module.ts",
		"common",
		"staff-routes-new_fee_report-module"
	],
	"./staff-routes/new_individual_concession/module": [
		"./src/app/modules/session/staff-routes/new_individual_concession/module.ts",
		"default~concession-add-module~fee_type_breakup_add-module~fee_type_breakup_list-module~new-concessio~4cd420e4",
		"common",
		"staff-routes-new_individual_concession-module"
	],
	"./staff-routes/other-fee-payment/module": [
		"./src/app/modules/session/staff-routes/other-fee-payment/module.ts",
		"default~online-payment-module~staff-routes-challan-module~staff-routes-fee-payment-module~staff-rout~185feaa2",
		"common",
		"staff-routes-other-fee-payment-module"
	],
	"./staff-routes/partial-payment/module": [
		"./src/app/modules/session/staff-routes/partial-payment/module.ts",
		"common",
		"staff-routes-partial-payment-module"
	],
	"./staff-routes/previous-academic-year-payment/module": [
		"./src/app/modules/session/staff-routes/previous-academic-year-payment/module.ts",
		"default~concession-add-module~fee_type_breakup_add-module~fee_type_breakup_list-module~new-concessio~4cd420e4",
		"default~online-payment-module~staff-routes-challan-module~staff-routes-fee-payment-module~staff-rout~185feaa2",
		"common",
		"staff-routes-previous-academic-year-payment-module"
	],
	"./staff-routes/previous-year-fee-payment-new-flow/module": [
		"./src/app/modules/session/staff-routes/previous-year-fee-payment-new-flow/module.ts",
		"default~online-payment-module~staff-routes-challan-module~staff-routes-fee-payment-module~staff-rout~185feaa2",
		"common",
		"staff-routes-previous-year-fee-payment-new-flow-module"
	],
	"./staff-routes/receipt-reprint/module": [
		"./src/app/modules/session/staff-routes/receipt-reprint/module.ts",
		"default~online-payment-module~staff-routes-challan-module~staff-routes-fee-payment-module~staff-rout~185feaa2",
		"common",
		"staff-routes-receipt-reprint-module"
	],
	"./staff-routes/regulations/module": [
		"./src/app/modules/session/staff-routes/regulations/module.ts",
		"default~regulation-entry-module~staff-routes-regulations-module",
		"common",
		"staff-routes-regulations-module"
	],
	"./staff-routes/result/module": [
		"./src/app/modules/session/staff-routes/result/module.ts",
		"common",
		"staff-routes-result-module"
	],
	"./staff-routes/screen/module": [
		"./src/app/modules/session/staff-routes/screen/module.ts",
		"common",
		"staff-routes-screen-module"
	],
	"./staff-routes/staff/module": [
		"./src/app/modules/session/staff-routes/staff/module.ts",
		"default~staff-entry-module~staff-routes-staff-module",
		"common",
		"staff-routes-staff-module"
	],
	"./staff-routes/student-dashboard/module": [
		"./src/app/modules/session/staff-routes/student-dashboard/module.ts",
		"default~staff-routes-student-dashboard-module~staff-routes-super-admin-dashboard-module~staff-routes~38482e48",
		"common",
		"staff-routes-student-dashboard-module"
	],
	"./staff-routes/student-photo-upload/module": [
		"./src/app/modules/session/staff-routes/student-photo-upload/module.ts",
		"common",
		"staff-routes-student-photo-upload-module"
	],
	"./staff-routes/student-tc-list/module": [
		"./src/app/modules/session/staff-routes/student-tc-list/module.ts",
		"staff-routes-student-tc-list-module"
	],
	"./staff-routes/student/module": [
		"./src/app/modules/session/staff-routes/student/module.ts",
		"staff-routes-student-module"
	],
	"./staff-routes/student_merit_update/module": [
		"./src/app/modules/session/staff-routes/student_merit_update/module.ts",
		"staff-routes-student_merit_update-module"
	],
	"./staff-routes/student_result/module": [
		"./src/app/modules/session/staff-routes/student_result/module.ts",
		"common",
		"staff-routes-student_result-module"
	],
	"./staff-routes/students-discontinued/module": [
		"./src/app/modules/session/staff-routes/students-discontinued/module.ts",
		"common",
		"staff-routes-students-discontinued-module"
	],
	"./staff-routes/subject-offer/module": [
		"./src/app/modules/session/staff-routes/subject-offer/module.ts",
		"staff-routes-subject-offer-module"
	],
	"./staff-routes/subject/module": [
		"./src/app/modules/session/staff-routes/subject/module.ts",
		"staff-routes-subject-module"
	],
	"./staff-routes/subject_wise_attendance/module": [
		"./src/app/modules/session/staff-routes/subject_wise_attendance/module.ts",
		"common",
		"staff-routes-subject_wise_attendance-module"
	],
	"./staff-routes/super-admin-dashboard/module": [
		"./src/app/modules/session/staff-routes/super-admin-dashboard/module.ts",
		"default~staff-routes-student-dashboard-module~staff-routes-super-admin-dashboard-module~staff-routes~38482e48",
		"common",
		"staff-routes-super-admin-dashboard-module"
	],
	"./staff-routes/syllabus-screen/module": [
		"./src/app/modules/session/staff-routes/syllabus-screen/module.ts",
		"common",
		"staff-routes-syllabus-screen-module"
	],
	"./staff-routes/teacher-assignment/module": [
		"./src/app/modules/session/staff-routes/teacher-assignment/module.ts",
		"staff-routes-teacher-assignment-module"
	],
	"./staff-routes/teacher-dashboard/module": [
		"./src/app/modules/session/staff-routes/teacher-dashboard/module.ts",
		"default~staff-routes-student-dashboard-module~staff-routes-super-admin-dashboard-module~staff-routes~38482e48",
		"common",
		"staff-routes-teacher-dashboard-module"
	],
	"./staff-routes/test-allotment/module": [
		"./src/app/modules/session/staff-routes/test-allotment/module.ts",
		"staff-routes-test-allotment-module"
	],
	"./staff-routes/test/module": [
		"./src/app/modules/session/staff-routes/test/module.ts",
		"staff-routes-test-module"
	],
	"./staff-routes/time-table-config/module": [
		"./src/app/modules/session/staff-routes/time-table-config/module.ts",
		"staff-routes-time-table-config-module"
	],
	"./staff-routes/time-table-upload/module": [
		"./src/app/modules/session/staff-routes/time-table-upload/module.ts",
		"default~staff-routes-student-dashboard-module~staff-routes-super-admin-dashboard-module~staff-routes~38482e48",
		"common",
		"staff-routes-time-table-upload-module"
	],
	"./staff-routes/time-table/module": [
		"./src/app/modules/session/staff-routes/time-table/module.ts",
		"default~staff-routes-student-dashboard-module~staff-routes-super-admin-dashboard-module~staff-routes~38482e48",
		"common",
		"staff-routes-time-table-module"
	],
	"./student-entry/module": [
		"./src/app/modules/session/staff-routes/student/student-entry/module.ts",
		"default~admission-view-module~student-entry-module",
		"common",
		"student-entry-module"
	],
	"./subject-add/module": [
		"./src/app/modules/session/staff-routes/subject/subject-add/module.ts",
		"common",
		"subject-add-module"
	],
	"./subject-list/module": [
		"./src/app/modules/session/staff-routes/subject/subject-list/module.ts",
		"common",
		"subject-list-module"
	],
	"./subject-offer-add/module": [
		"./src/app/modules/session/staff-routes/subject-offer/subject-offer-add/module.ts",
		"common",
		"subject-offer-add-module"
	],
	"./subject-offer-list/module": [
		"./src/app/modules/session/staff-routes/subject-offer/subject-offer-list/module.ts",
		"common",
		"subject-offer-list-module"
	],
	"./teacher-assignment-add/module": [
		"./src/app/modules/session/staff-routes/teacher-assignment/teacher-assignment-add/module.ts",
		"teacher-assignment-add-module"
	],
	"./teacher-assignment-list/module": [
		"./src/app/modules/session/staff-routes/teacher-assignment/teacher-assignment-list/module.ts",
		"common",
		"teacher-assignment-list-module"
	],
	"./test-add/module": [
		"./src/app/modules/session/staff-routes/test/test-add/module.ts",
		"common",
		"test-add-module"
	],
	"./test-allotment-add/module": [
		"./src/app/modules/session/staff-routes/test-allotment/test-allotment-add/module.ts",
		"common",
		"test-allotment-add-module"
	],
	"./test-allotment-list/module": [
		"./src/app/modules/session/staff-routes/test-allotment/test-allotment-list/module.ts",
		"common",
		"test-allotment-list-module"
	],
	"./test-allotment-view/module": [
		"./src/app/modules/session/staff-routes/test-allotment/test-allotment-view/module.ts",
		"common",
		"test-allotment-view-module"
	],
	"./test-list/module": [
		"./src/app/modules/session/staff-routes/test/test-list/module.ts",
		"common",
		"test-list-module"
	],
	"./time-table-config-add/module": [
		"./src/app/modules/session/staff-routes/time-table-config/time-table-config-add/module.ts",
		"common",
		"time-table-config-add-module"
	],
	"./time-table-config-edit/module": [
		"./src/app/modules/session/staff-routes/time-table-config/time-table-config-edit/module.ts",
		"common",
		"time-table-config-edit-module"
	],
	"./time-table-config-list/module": [
		"./src/app/modules/session/staff-routes/time-table-config/time-table-config-list/module.ts",
		"common",
		"time-table-config-list-module"
	],
	"./time-table-config-view/module": [
		"./src/app/modules/session/staff-routes/time-table-config/time-table-config-view/module.ts",
		"common",
		"time-table-config-view-module"
	],
	"./view/module": [
		"./src/app/modules/session/staff-routes/student_merit_update/view/module.ts",
		"view-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;